import { render } from "./myCon.vue?vue&type=template&id=2881b771&scoped=true"
import script from "./myCon.vue?vue&type=script&lang=js"
export * from "./myCon.vue?vue&type=script&lang=js"

import "./myCon.vue?vue&type=style&index=0&id=2881b771&lang=scss"
import "./myCon.vue?vue&type=style&index=1&id=2881b771&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2881b771"]])

export default __exports__